/*!
 * Copyright © 2019. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EMapHierarchyMaxSelectionType {
  Vehicles,
  Assets
}
